import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  RequestCreateNewAgent,
  ResetCreateNewAgent,
} from "../../../../../store/actions/integrationsActions";
import CopyButton from "../../../../../Components/common/CopyButton/CopyButton";
import CustomSelect from "../../../../../Components/common/CustomSelect/CustomSelect";
import LinkIcon2 from "../../../../../Components/Icon-SVG/LinkIcon2";

import { AGENT_OS_OPTIONS, DEFAULT_AGENT_OS } from "../../../../../utils/constants/agentOs";

import "./styles.scss";

const AgentURLPopup = ({ setShow, protocol, hostname }) => {
  const dispatch = useDispatch();

  const newAgentUrl = useSelector((state) => state.integrations.newAgentUrl);
  const loading = useSelector((state) => state.integrations.loading);
  const error = useSelector((state) => state.integrations.error);

  const [uniqueID, setUniqueID] = useState("");
  const [clientDesc, setClientDesc] = useState("");
  const [selectedOs, setSelectedOs] = useState(DEFAULT_AGENT_OS);

  useEffect(() => {
    if (error) {
      setUniqueID("");
    }
  }, [error]);

  const submitHandler = () => {
    dispatch(
      RequestCreateNewAgent({
        clientID: uniqueID,
        serverIp: hostname,
        clientDesc: clientDesc,
        os: selectedOs.id,
      }),
    );
  };

  useEffect(() => {
    dispatch(ResetCreateNewAgent());
  }, [dispatch]);

  return (
    <div className={`${"popup-form-backdrop"}`} onClick={() => setShow(false)}>
      <div onClick={(e) => e.stopPropagation()}>
        <div className="popup-form">
          <h3 className="popup-form__article">New Agent</h3>
          {loading && <div>Loading...</div>}
          {!loading && !newAgentUrl && (
            <>
              <p className="popup-form__description">
                Please enter a unique identifier to create a download URL.
              </p>
              <input
                className={`popup-form__field`}
                value={uniqueID}
                onChange={(e) => setUniqueID(e.target.value)}
                type="text"
                placeholder="Unique ID"
              />
              <input
                className={`popup-form__field`}
                value={clientDesc}
                onChange={(e) => setClientDesc(e.target.value)}
                type="text"
                placeholder="Description (Optional)"
              />
              <div className="popup-form__os-select">
                <p className="popup-form__os-select__label">Operating System</p>
                <CustomSelect
                  width="240px"
                  height="40px"
                  data={AGENT_OS_OPTIONS}
                  select={selectedOs}
                  setSelected={setSelectedOs}
                />
              </div>
              {error && !uniqueID && <div className="popup-form__input-error">{error}</div>}
              <div className="flex" style={{ marginTop: "20px" }}>
                <button className="primary-button" onClick={submitHandler}>
                  Create
                </button>

                <button className="danger-button" onClick={() => setShow(false)}>
                  Cancel
                </button>
              </div>
            </>
          )}
          {!loading && newAgentUrl && (
            <>
              <p className="popup-form__description">
                You can download the agent from the provided link.
              </p>
              <div className="popup-form__url-area">
                <CopyButton
                  title="Copy Link"
                  itemToCopy={`${protocol}//${hostname}/${newAgentUrl}`}
                  icon={LinkIcon2}
                />
                <div className="popup-form__url-area__url">
                  {`${protocol}//${hostname}/${newAgentUrl}`}
                </div>
              </div>
              <button className="primary-button" onClick={() => setShow(false)}>
                Close
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgentURLPopup;
